import { ApolloClient, HttpLink, InMemoryCache, from } from '@apollo/client/core'
import { onError } from '@apollo/client/link/error'
import { setContext  } from '@apollo/client/link/context'
// import { WebSocketLink } from '@apollo/client/link/ws'
import { createApolloProvider } from '@vue/apollo-option'
import { usePage } from '@inertiajs/inertia-vue3'
import { axios } from 'axios'

const httpLink = new HttpLink({
  uri: '/graphql',
})

const errorLink = onError(({ graphQLErrors, networkError }) => {
  if (networkError?.statusCode === 419) {
    // Optional: Seite neu laden oder zur Login-Seite umleiten
    window.location.reload()
  }
})

// XSRF token is required to make post requests to your Laravel backend
const authLink = setContext((_, { headers }) => {
  let csfrToken = usePage().props.value.csrfToken

  // setInterval(async () => {
  //     await axios.get('/sanctum/csrf-cookie')
  //     csrfToken.value = document.querySelector('meta[name="csrf-token"]').content
  // }, 115 * 60 * 1000)

  return {
    headers: {
      ...headers,
      'X-CSRF-TOKEN': csfrToken,
      accept: 'application/json',
    }
  }
});

// Create the apollo client
const apolloClient = new ApolloClient({
  link: from([errorLink, authLink, httpLink]),
  cache: new InMemoryCache(),
  defaultOptions: {
    watchQuery: {
      fetchPolicy: 'network-only',
      errorPolicy: 'all',
    },
    query: {
      fetchPolicy: 'network-only',
      errorPolicy: 'all',
    },
  },
  connectToDevTools: true,
  credentials: 'same-origin',
})

// Create a provider
export default createApolloProvider({
  defaultClient: apolloClient,
})
